import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { FetchPageComponent }  from '@components/pages/fetch/fetch.component';
import { DashComponent }  from '@components/pages/dash/dash.component';
import { RecordingComponent } from '@components/pages/fetch/recording/recording.component';

const routes: Routes = [
  //{ path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: DashComponent },
  { path: 'dash', component: DashComponent },
  { path: 'record', component: RecordingComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  declarations: []
})
export class AppRoutingModule {}
